// extracted by mini-css-extract-plugin
export default {"page":"styles_page__GRuKl","img":"styles_img__wgzAC","mobile":"styles_mobile__CpoN6"};